import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { hasPartnersDecoupled } from 'utils/showDetails';

export type UserSocietyContext = {
  societyId?: string;
  societyName?: string;
  userId?: string;
  userEmail?: string;
  userName?: string;
  userRole?: string;
  partnerId?: string;
};

const resolveRole = (role: Record<string, any> | undefined): string => {
  if (!role) return 'unknown';
  if (role.isAdmin) return 'admin';
  if (role.isPartner) return 'partner';
  if (role.isBeneficiary) return 'beneficiary';
  if (role.isInvestor) return 'investor';
  if (role.isDirector) return 'director';
  if (role.isRepresentant) return 'representant';
  if (role.isHolder) return 'holder';
  if (role.isGuest) return 'guest';
  return 'unknown';
};

export const useUserSocietyContext = (): UserSocietyContext => {
  const user = useSelector((state: State) => state.user);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const role = useSelector((state: State) => state.society?.role);

  const partners = useSelector((state: State) =>
    hasPartnersDecoupled() ? state.partners : actualSociety?.partners
  );

  const partnerId = partners?.find(
    (partner: any) =>
      partner?.user === user?._id ||
      partner?.otherUsers?.includes(user?._id)
  )?._id;

  return {
    societyId: actualSociety?.['_id'],
    societyName: actualSociety?.name,
    userId: user?._id,
    userEmail: user?.email,
    userName: user?.name,
    userRole: resolveRole(role),
    partnerId,
  };
};

export default useUserSocietyContext;
